import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { DataValueMap } from 'Helpers/Testing';
import List1 from 'Components/ComponentLibrary/Components/Lists/List1';
import ListItem1 from 'Components/ComponentLibrary/Components/ListItems/ListItem1';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import {
  THREAD_TYPE_QUERY_FIELD,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters';

const MemberThreadFilterMenu = ({
  resource, onChange, handleClose, classes,
}) => {
  return (
    <List1>
      <ListItem1
        key={'archived'}
        selected={resource.isTruthy('isArchived')}
        button
        onClick={() => {
          onChange(!resource.isTruthy('isArchived'), 'isArchived');
          handleClose();
        }}
        classes={{
          selected: classes.selected,
        }}
        {...DataValueMap.init('thread-list-filter-archived').build()}
      >
        <Typography
          color={resource.isTruthy('isArchived') ? 'white' : 'primary'}
          variant={'subtitle2'}
          weight={'book'}
        >
          {'Archived'}
        </Typography>
      </ListItem1>
      { resource.meta().field(THREAD_TYPE_QUERY_FIELD).options().list()
        .map((option) => {
          const selected = resource.attr(THREAD_TYPE_QUERY_FIELD) === option.attr('id');
          return (
            <ListItem1
              key={option.attr('id')}
              selected={selected}
              button
              onClick={() => {
                onChange(selected ? null : option.attr('id'), THREAD_TYPE_QUERY_FIELD);
                handleClose();
              }}
              classes={{
                selected: classes.selected,
              }}
              {...DataValueMap.init(`thread-list-filter-${option.attr('id')}`).build()}
            >
              <Typography
                color={selected ? 'white' : 'primary'}
                variant={'subtitle2'}
                weight={'book'}
              >
                {option.attr('prompt')}
              </Typography>
            </ListItem1>
          );
        })}
    </List1>
  );
};

MemberThreadFilterMenu.defaultProps = {
};

MemberThreadFilterMenu.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  handleClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export {
  MemberThreadFilterMenu,
};
